export default {
  'da': {
    'jobs_header': 'Vi er på udkig efter...',
    'jobs': [
      // {
      //   'title': 'Compliance and Legal Specialist\n',
      //   'body': `Læs mere om stillingen hos <a target="_blank" href="https://www.jobindex.dk/jobannonce/468284/compliance-and-legal-specialist">Jobindex</a>.`
      // }
    ],
    'headline': 'LEDIGE STILLINGER',
    'paragraph': '<p><strong>Har det fanget din interesse?</strong> Selv når vi ikke har nogen ledige stillinger, er vi på udkig efter nye talentfulde medarbejdere, som kan slutte sig til vores vinderhold. Bare send os din ansøgning!</p>',
    'list_header': 'Det bedste ved at arbejde i vores by',
    'list': [
      '<p><strong>Arbejd med den seneste teknologi</strong> inden for programmering og drift.</p>',
      '<p>Slut dig til et stærkt og professionelt hold <strong>og udvikl dine kompetencer til nye højder.</strong></p>',
      '<p>Vær en del af en succes, som<strong> udvikler morgendagens spændende nye platforme.</strong></p>',
      '<p><strong>Alle har en vigtig rolle</strong> og resultaterne er altid opnået i tæt samarbejde.</p>',
      '<p>God plads til at <strong>nørde, være kreativ og videreudvikle dine ideer og evner.</strong></p>'
    ],
    'letter_copy': 'Selv når vi ikke har nogen ledige stillinger, er vi på udkig efter nye talentfulde medarbejdere, som kan slutte sig til vores vinderhold. Bare send os din ansøgning!'
  },
  'en': {
    'jobs_header': 'We are searching for...',
    'jobs': [
      // {
      //   'title': 'Compliance and Legal Specialist\n',
      //   'body': `Read more about the position at <a target="_blank" href="https://www.jobindex.dk/jobannonce/468284/compliance-and-legal-specialist">Jobindex</a>.`
      // }
    ],
    'headline': 'Vacant positions',
    'paragraph': '<p><strong>See something that interests you?</strong> Even if we don\'t have a current opening, we’re always looking for talented new members that can join our winning team. Just send us your application!</p>',
    'list_header': 'The best about working in our city',
    'list': [
      '<p><strong>Work with the latest technologies</strong> in both programming and operation.</p>',
      '<p>Enter into a strong professional team and <strong>boost your own skills to new heights.</strong></p>',
      '<p>Be a part of a success that <strong>creates tomorrow\'s exciting new platforms.</strong></p>',
      '<p><strong>Everyone has an important role</strong> and the results are always generated in close cooperation.</p>',
      '<p>Plenty of room for <strong>nerd stuff, creativity and development of ideas and skills.</strong></p>'
    ],
    'letter_copy': 'Even if we don\'t have a current opening, we’re always looking for talented new members for our winning team. Just send us your application.'
  },
};



// WEBPACK FOOTER //
// ./src/multilanguage/positions.js